'use client'

import { createStore } from '@ntc/lib/utils/context-utils'

import { LegalModalProps } from '@src/app/[locale]/_components/homepage/LegalModal'

export type HomePageContextData = ReturnType<typeof useStore>['store']

const defaultStore: {
  legalModal: LegalModalProps & { isOpen: boolean }
} = {
  legalModal: {
    isOpen: false
  }
}

const { StoreProvider, useStore } = createStore({
  defaultStore,
  actions: {
    setLegalModal: (slice, legalModal: (typeof defaultStore)['legalModal']) => {
      slice.legalModal = legalModal
    }
  }
})

export const useHomePageContext = useStore

export const HomePageContext = StoreProvider
